import React, { createContext, useContext, useState } from 'react';

const InvoiceModalContext = createContext({
  invoiceModalOpen: false,
  setInvoiceModalOpen: () => {},
});

export function InvoiceModalProvider({ children }) {
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  return (
    <InvoiceModalContext.Provider value={{ invoiceModalOpen, setInvoiceModalOpen }}>
      {children}
    </InvoiceModalContext.Provider>
  );
}

export function useInvoiceModal() {
  const context = useContext(InvoiceModalContext);
  if (!context) {
    throw new Error('useInvoiceModal must be used within InvoiceModalProvider');
  }
  return context;
}
